

export class CityUpdateInput implements ICityUpdateInput {
    /** The auto-generated id of the city master */
    cityId!: number;
    /** The state name with 255 character limit */
    cityName!: string;

    constructor(data?: ICityUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
        }
    }

    static fromJS(data: any): CityUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CityUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        return data; 
    }
}

export interface ICityUpdateInput {
    /** The auto-generated id of the city master */
    cityId: number;
    /** The state name with 255 character limit */
    cityName: string;
}

